import * as Yup from "yup";

const LoginSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  password: Yup.string().required("Password Is Required"),
});

export default LoginSchema;
